import React, { Component } from "react";
import "antd/dist/antd.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {
  Row,
  Col,
  Select,
  Button,
  Spin,
  message,
  notification,
  Table,
} from "antd";
import { Link } from "react-router-dom";
import AppConfigs from "../../Config/AppConfig";
import { getDetails, add, list } from "../../api/Apis";
import { Storage } from "aws-amplify";
import { withRouter } from "react-router";
import { withAppContext } from "../../store/contextStore";
import NumberFormat from "react-number-format";
import { ArrowLeftOutlined } from "@ant-design/icons";

const { Option } = Select;

class Stonedetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 0,
      measurementType: "",
      productsData: [],
      stoneData: [],
      orgDetails: {},
      selectedSize: "",
      deliveryTruck: "Tractor Trailer",
      deliveryCharges: "",
      addToCartLoading: false,
      addToCartMilfordLoading: false,
      dataLoadingStatus: true,
      itemType: "",
      stoneWeight: "",
      southernStates: "",
      northernStates: "",
      userDetails: JSON.parse(localStorage.getItem("userDetails")),
    };
  }
  increment = () => {
    this.setState({
      count: this.state.count + 1,
    });
  };

  decrement = () => {
    this.setState({
      count: this.state.count - 1,
    });
  };

  componentDidMount() {
    let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let sizefilter = params.get("size");
    let itemfilter = params.get("itemType");
    this.setState({
      orgDetails: orgDetails,
      selectedSize: sizefilter,
      itemType: itemfilter,
    });
    let query = {
      size: sizefilter,
    };
    list(
      `${AppConfigs["getProductDetails"]}/${this.props.match.params.id}`,
      query
    ).then(async (result) => {
      if (result.success) {
        let finalSizes = result.data.sizes;
        let imagepath = await Storage.get(result.data?.["images"]?.[0]);
        if (this.state.userDetails.userProfile !== "CU") {
          finalSizes = result.data.sizes.filter((item) =>
            this.state.userDetails?.locations?.includes(item.location)
          );
        }
        result.data.sizes = finalSizes.filter((item)=>{return item.price!=="0"});
        this.setState({
          productsData: result.data,
        });
        let stoneWeight =
          result.data["productCategory"] ===
          "37638d60-2b19-11eb-b05c-a3fa7baaf1b5"
            ? 1
            : 1.5;
        this.setState({ stoneWeight });
        if (itemfilter === "pallet") {
          this.setState({
            measurementType: "Pallet",
            deliveryTruck: "CustomerPickup",
          });
        } else {
          this.setState({
            count: 1,
            measurementType: "Truckload",
          });
        }
        if (sizefilter !== "undefined") {
          let sizesData = result.data.sizes.filter(
            (size) => size.size === sizefilter 
          );
          if (sizesData && sizesData[0]) {
            if(sizesData[0]["sizeUploadImg"]!==null){
            sizesData[0]["imagepath"] = await Storage.get(
              result.data.productCode.replace(/\s+/g, "") +
                "_" +
                sizesData[0]["sizeUploadImg"]
            );
            }
            else{
              sizesData[0]["imagepath"]=imagepath
            }
          }
          this.setState({
            stoneData: sizesData,
            dataLoadingStatus: false,
          });
        } else {
          let sizesData = [{ ...result.data }];
          if (result.data) {
            sizesData[0]["imagepath"] = await Storage.get(
              result.data.productCode + result.data?.["images"]?.[0]
            );
          }
          this.setState({
            stoneData: sizesData,
            dataLoadingStatus: false,
          });
        }
      } else {
        console.log(result.errors);
        this.setState({
          dataLoadingStatus: false,
        });
      }
    });
    getDetails(
      AppConfigs["entityNames"]["organizations"],
      orgDetails["orgId"]
    ).then((result) => {
      if (result.success) {
        this.setState({
          deliveryCharges: result["data"]["settings"]
            ? result["data"]["settings"]["deliveryFee"]
            : 0,
          southernStates: result["data"]["southernStates"],
          northernStates: result["data"]["northernStates"],
        });
      } else {
        this.setState({
          loading: false,
          errors: result.errors,
        });
      }
    });
  }

  addToCart = (location) => {
    // let tonValue =
    //   this.state.stoneWeight !== ""
    //     ? this.state.stoneWeight
    //     : this.state.stoneData[0]["pallet"] !;

    // let palletValue = this.state.stoneData.filter(
    //   (p) => p.ton === tonValue && p
    // );
    // if (palletValue[0].pallet === "0") {
    //   message.error("This product is currently not available by the pallet");
    //   return;
    // } else
    if (this.state.measurementType === "") {
      // alert("Please select measurement");
      message.error("Please select measurement");
      return;
    } else if (this.state.count === 0) {
      // alert("Please select quantity");
      message.error("Please select quantity");
      return;
    } else if (
      this.state.deliveryTruck === "" &&
      this.state.measurementType === "Truckload"
    ) {
      // alert("Please select quantity");
      message.error("Please select Delivery Truck");
      return;
    } else if (
      this.state.measurementType === "Truckload" &&
      this.state.stoneData?.[0]?.["truckload"] === "0"
    ) {
      // alert("Please select quantity");
      message.error("This product is currently not available by the truckload");
      return;
    }
    //  else if (this.state.stoneData[0]["ton"] === "0") {
    //   // alert("Please select quantity");
    //   message.error("This product is currently not available by the ton");
    //   return;
    // }

    if (this.state.measurementType === "Truckload" && this.state.count > 1) {
      message.error("Only 1 truckload can be ordered at a time.");
      return;
    }
    // if (location === "Milford") {
    //   this.setState({
    //     addToCartMilfordLoading: true,
    //   });
    // } else {
    this.setState({
      addToCartLoading: true,
    });
    // }
    let data = {
      entityData: {
        productId: this.props.match.params.id,
        size: this.state.stoneData?.[0]?.["size"]
          ? this.state.stoneData?.[0]?.["size"]
          : this.state.selectedSize,
        ton:
          this.state.stoneWeight !== ""
            ? this.state.stoneWeight
            : this.state.stoneData[0]["pallet"] !== "0"
            ? this.state.stoneData[0]["ton"]
            : this.state.stoneData[1]["ton"],
        locationName: location,
        productLinkId: this.state.productsData["productId"],
        measurementType: this.state.measurementType,
        deliveryTruck:
          this.state.deliveryTruck !== "" ? this.state.deliveryTruck : null,
        quantity: this.state.count,
        customerId: this.state.orgDetails["id"],
        orgId: this.state.orgDetails["orgId"],
        itemType: this.state.itemType,
        totalAmt:
          (String(this.state.stoneData[0]?.price).indexOf("$") > 0
            ? parseFloat(this.state.stoneData[0]?.price.slice(2)).toFixed(2)
            : parseFloat(this.state.stoneData[0]?.price).toFixed(2)) *
          this.state.count,
      },
    };
    let existingCartData = JSON.parse(localStorage.getItem("cartData"));
    // if (
    //   existingCartData &&
    //   existingCartData[0] &&
    //   existingCartData[0].deliveryTruck &&
    //   existingCartData[0].deliveryTruck !== this.state.deliveryTruck &&
    //   existingCartData[0].measurementType !== "Pallet"
    // ) {
    //   if (
    //     (this.state.measurementType === "Pallet" &&
    //       existingCartData[0].measurementType !== "Pallet") ||
    //     (this.state.measurementType === "Truckload" &&
    //       existingCartData[0].measurementType === "Pallet")
    //   ) {
    //     notification["error"]({
    //       message: `You can only order bulk gravel or pallets in a single order. Please create separate orders for each`,
    //     });
    //     this.setState({
    //       addToCartLoading: false,
    //       addToCartMilfordLoading: false,
    //     });
    //     return;
    //   }
    //   // notification["error"]({
    //   //   message: `Your cart has a ${
    //   //     existingCartData[0].measurementType === "Pallet"
    //   //       ? "Pallet"
    //   //       : existingCartData[0].deliveryTruck
    //   //   } ordered with a different truck type.${
    //   //     existingCartData[0].measurementType === "Pallet"
    //   //       ? " Please select only one truck type for up to 24 pallets in each order. Thank you"
    //   //       : "Please select only one truck type in each order. Thank you"
    //   //   } .`,
    //   // });
    //   this.setState({
    //     addToCartLoading: false,
    //     addToCartMilfordLoading: false,
    //   });
    //   // return;
    // }

    const { stoneWeight, stoneData } = this.state;
    let total_weight = 0;
    if (existingCartData != null) {
      existingCartData.map((d) => (total_weight = total_weight + d.weight));
    }
    let check_total_weight;
    let ton = 0;
    if (existingCartData != null) {
      existingCartData.map((d) => (ton = ton + d.ton));
    }
    let totalQuantity = ton + stoneWeight ? stoneWeight : stoneData[0]["ton"];

    //  if (ton > 24 || stoneWeight > 24 || totalQuantity > 24) {
    if (this.state.count > 24 || totalQuantity > 24) {
      notification["error"]({
        message:
          "You can only order up to 24 pallets per truck in a single order. If you wish to order more than 24 pallets, please create a new order with the additional pallets. Thank you.",
      });
      this.setState({
        addToCartLoading: false,
      });
      return;
    }
    // if (
    //   existingCartData &&
    //   existingCartData[0] &&
    //   existingCartData[0].measurementType === "Truckload"
    //   // quantity < 2
    // ) {
    //   notification["error"]({
    //     message: "You can only place one truckload per order",
    //   });
    //   this.setState({
    //     addToCartLoading: false,
    //     addToCartMilfordLoading: false,
    //   });
    //   return;
    // }
    if (this.state.measurementType !== "Truckload") {
      let numOfTons;
      let checkProduct =
        existingCartData !== null &&
        existingCartData.filter(
          (c) =>
            c.productId === this.props.match.params.id &&
            this.state.measurementType === c.measurementType &&
            this.state.stoneData[0]["size"] === c.size
        );
      if (checkProduct.length > 0) {
        data["entityData"]["quantity"] =
          parseInt(checkProduct[0]["quantity"]) + parseInt(this.state.count);
        data["entityData"]["id"] = checkProduct[0]["id"];
        let totalTon =
          parseFloat(data["entityData"]["ton"].split(" Ton")[0]) *
          parseInt(this.state.count);
        numOfTons =
          parseFloat(checkProduct[0]["weight"]) + parseFloat(totalTon);
        // data["entityData"]["wieght"] = numOfTons;
      } else {
        let totalTon = data["entityData"]?.["ton"];
        numOfTons = parseFloat(totalTon) * data["entityData"]["quantity"];
        // data["entityData"]["wieght"] = numOfTons;
      }
      check_total_weight = total_weight + this.state.count;
      data["entityData"]["wieght"] = numOfTons;

      data["entityData"]["ton"] =
        this.state.stoneWeight !== ""
          ? this.state.stoneWeight
          : this.state.stoneData.length > 0 && this.state.stoneData[0]?.ton;
    }
    if (data["entityData"]["wieght"] > 24 || check_total_weight > 24) {
      notification["error"]({
        message:
          "An order can have a max of 24 tons. Please remove some items from the cart to proceed.",
      });
      this.setState({
        addToCartLoading: false,
        addToCartMilfordLoading: false,
      });
      return;
    }
    add(AppConfigs["addItemToCart"], data).then((result) => {
      if (result.success) {
        let cartData = result.data.data;
        cartData &&
          cartData.map(async (item, index) => {
            item["originalPath"] = item["image"];
            item["image"] = await Storage.get(item["image"]);
            if (cartData.length === index + 1) {
              this.props.context.setCartData(cartData);
              localStorage.setItem("cartData", JSON.stringify(cartData));
              message.success("Product added to cart");
            }
          });
      } else {
        message.error(`Product not added to cart`);
        console.log(result.errors);
      }
      this.setState({
        addToCartLoading: false,
        deliveryTruck: "",
      });
      // window.location.reload();
    });
  };

  render() {
    const { itemType, stoneWeight, southernStates } = this.state;
    const bulkGravelData = [
      {
        title: (
          <div className="list-head" style={{ color: "grey" }}>
            Location
          </div>
        ),
        dataIndex: "location",
        key: "location",
        align: "left",
        className: "stones-table-location",
        render: (location) => <div style={{ color: "black" }}>{location}</div>,
      },
      {
        title: (
          <div className="list-head" style={{ color: "grey" }}>
            Per Ton
          </div>
        ),
        dataIndex: "price",
        key: "price",
        className: "stones-table-price",
        render: (price, data) => (
          <div style={{ color: "black" }}>
            <NumberFormat
              value={parseFloat(price).toFixed(2)}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />
          </div>
        ),
      },
      {
        title: (
          <div className="list-head" style={{ color: "grey" }}>
            Per Truckload
          </div>
        ),
        dataIndex: "price",
        key: "price",
        className: "stones-table-truckload",
        render: (price) => (
          <div style={{ color: "black" }}>
            <NumberFormat
              value={parseFloat(price * 23).toFixed(2)}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />
          </div>
        ),
      },
      {
        title: (
          <div className="list-head" style={{ color: "grey", width: "150px" }}>
            Delivery Truck
          </div>
        ),
        dataIndex: "price",
        key: "price",
        className: "stones-table-deliveryTruck",
        render: (price, data) => (
          <div style={{ color: "black" }}>
            <Select
              className="deliveryTruckSelect"
              notFoundContent={"Not found?!"}
              placeholder="Delivery Truck"
              defaultValue={["Tractor Trailer"]}
              onChange={(value) => this.setState({ deliveryTruck: value })}
              mode="multiple"
              style={{ width: "90%" }}
            >
              <Option value="Tractor Trailer">Tractor Trailer</Option>
              <Option value="Dump Truck/Triaxle">Dump Truck/Triaxle</Option>
              <Option value="Mason Dump">Mason Dump</Option>
              <Option value="OpenTop">Open Top Hopper Railcar</Option>
              <Option value="GondolaRailcar">Gondola Railcar</Option>
              <Option value="Customer Pickup">Customer Pickup</Option>
            </Select>
          </div>
        ),
      },
      {
        title: (
          <div className="list-head" style={{ color: "grey" }}>
            Action
          </div>
        ),
        dataIndex: "location",
        key: "location",
        className: "stones-table-button",
        render: (location) => (
          <Button
            className="orderbtn"
            onClick={() => this.addToCart(location)}
            // loading={
            //   location === "Milford"
            //     ? this.state.addToCartMilfordLoading
            //     : this.state.addToCartLoading
            // }
          >
            Add to Cart
          </Button>
        ),
      },
    ];
    return (
      <div
        style={{
          padding: "40px",
          backgroundColor: "white",
          height: "fit-content",
        }}
      >
        <Row>
          <Col
            span={23}
            offset={1}
            style={{ fontSize: "18px", cursor: "pointer" }}
          >
            <Link
              to={{
                pathname: "/app/stones",
                state:
                  itemType === "bulk"
                    ? "Bulk Gravel"
                    : itemType === "pallet"
                    ? "Palletized Stone"
                    : "Other products",
              }}
              style={{
                textDecoration: "none",
                color: "black",
                marginLeft: "1vw",
                cursor: "pointer",
              }}
            >
              <ArrowLeftOutlined />
              <span style={{ marginLeft: "5px" }}>Back</span>
            </Link>
          </Col>
          <Spin spinning={this.state.dataLoadingStatus}>
            <Col xxl={12} xl={10} lg={10} md={10} sm={24} xs={24}>
              <div style={{ textAlign: "center", marginTop: "7%" }}>
                <img
                  src={
                    this.state.stoneData.length > 0
                      ? this.state.stoneData[0].imagepath
                      : 0
                  }
                  alt="Not Uploaded"
                  style={{ width: "60%" }}
                />
              </div>
            </Col>
            <Col xxl={12} xl={14} lg={14} md={14} sm={24} xs={24}>
              <div className="detailstext">
                <h3 className="stonename">
                  {this.state.selectedSize !== "undefined"
                    ? this.state.selectedSize
                    : ""}
                  {this.state.productsData["productName"]}
                </h3>
                <p className="stonetext">
                  {this.state.productsData["description"]}
                </p>
                <Row>
                  {itemType === "pallet" && (
                    <>
                      <Col lg={7} md={7} sm={24} xs={24}>
                        <h4 className="perton">
                          Weight:
                          <span className="cost">
                            {this.state.stoneData.length > 0 && (
                              <Select
                                onChange={(value) =>
                                  this.setState({
                                    stoneWeight:
                                      this.state.productsData[
                                        "productCategory"
                                      ] ===
                                      "37638d60-2b19-11eb-b05c-a3fa7baaf1b5"
                                        ? 1
                                        : 1.5,
                                  })
                                }
                                style={{ width: "50%" }}
                                // defaultValue={
                                //   this.state.stoneData[0].pallet !== "0"
                                //     ? this.state.stoneData[0]?.ton
                                //     : this.state.stoneData[1]?.ton
                                // }
                                defaultValue={
                                  this.state.productsData["productCategory"] ===
                                  "37638d60-2b19-11eb-b05c-a3fa7baaf1b4"
                                    ? 1.5
                                    : 1
                                }
                                disabled={true}
                              >
                                {/* <Option key={1.5} value={1.5}>
                                  {this.state.productsData[
                                    "productCategory"
                                  ] === "37638d60-2b19-11eb-b05c-a3fa7baaf1b5"
                                    ? 1.5
                                    : 1}
                                </Option> */}
                                {/* {this.state.stoneData.map(
                                  (ton) =>
                                    ton.pallet !== "0" && (
                                      <Option key={ton.ton} value={ton.ton}>
                                        {ton.ton}
                                      </Option>
                                    )
                                )} */}
                                {/* {[
                                  ...new Map(
                                    this.state.stoneData.map((item) => [
                                      item["ton"],
                                      item,
                                    ])
                                  ).values(),
                                ].map((ton) => (
                                  <Option key={ton.ton} value={ton.ton}>
                                    {ton.ton}
                                  </Option>
                                ))} */}
                              </Select>
                            )}
                          </span>
                        </h4>
                      </Col>
                      <Col lg={7} md={7} sm={24} xs={24}>
                        <h4 className="perton">
                          Price:
                          {/* <span className="cost">
                            {this.state.stoneData.length > 0 ? (
                              stoneWeight !== "" ? (
                                [
                                  ...new Map(
                                    this.state.stoneData.map((item) => [
                                      item["ton"],
                                      item,
                                    ])
                                  ).values(),
                                ].map(
                                  (ton) =>
                                    ton.ton === stoneWeight && (
                                      <NumberFormat
                                        value={parseFloat(ton.price).toFixed(2)}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        prefix={"$"}
                                      />
                                    )
                                )
                              ) : (
                                <NumberFormat
                                  value={parseFloat(
                                    this.state.stoneData[0]?.price
                                  ).toFixed(2)}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"$"}
                                />
                              )
                            ) : (
                              0
                            )}
                          </span> */}
                          <span className="cost">
                            {stoneWeight === "" ? (
                              this.state.stoneData[0]?.price !== "0" ? (
                                <NumberFormat
                                  value={
                                    this.state.stoneData[0]?.price.includes("$")
                                      ? parseFloat(
                                          this.state.stoneData[0]?.price.slice(
                                            2
                                          )
                                        ).toFixed(2)
                                      : parseFloat(
                                          this.state.stoneData[0]?.price
                                        ).toFixed(2)
                                  }
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"$"}
                                />
                              ) : (
                                <NumberFormat
                                  value={
                                    this.state.stoneData[0]?.price.includes("$")
                                      ? parseFloat(
                                          this.state.stoneData[0]?.price.slice(
                                            2
                                          )
                                        ).toFixed(2)
                                      : parseFloat(
                                          this.state.stoneData[0]?.price
                                        ).toFixed(2)
                                  }
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"$"}
                                />
                              )
                            ) : (
                              this.state.stoneData.map(
                                (item) => (
                                  // item.ton === stoneWeight && (
                                  <NumberFormat
                                    value={
                                      this.state.stoneData[0]?.price?.includes(
                                        "$"
                                      )
                                        ? parseFloat(
                                            this.state.stoneData[0]?.price?.slice(
                                              2
                                            )
                                          ).toFixed(2)
                                        : parseFloat(item.price).toFixed(2)
                                    }
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    prefix={"$"}
                                  />
                                )
                                // )
                              )
                            )}
                          </span>
                        </h4>
                      </Col>
                    </>
                  )}
                </Row>

                <Row
                  style={{
                    paddingBottom: "20px",
                    borderBottom: "1px solid  #f2f3f6a4",
                    marginBottom: "20px",
                    paddingTop: "20px",
                  }}
                >
                  {itemType === "bulk" ? (
                    <Table
                      columns={bulkGravelData}
                      dataSource={this.state.productsData.sizes}
                      pagination={false}
                      loading={this.state.addToCartLoading}
                      style={{ overflowX: "auto" }}
                    ></Table>
                  ) : (
                    <Row className="stones_item">
                      <Col lg={7} md={7} sm={24} xs={24}>
                        <span className="perton">Quantity:</span>
                        {this.state.count === 0 ? (
                          <Button disabled className="quantitybtn">
                            -
                          </Button>
                        ) : (
                          <Button
                            onClick={this.decrement}
                            className="quantitybtn"
                          >
                            -
                          </Button>
                        )}
                        <span className="count">{this.state.count}</span>
                        {(this.state.stoneWeight === 1 &&
                          this.state.count === 24) ||
                        (this.state.stoneWeight === 1.5 &&
                          this.state.count === 16) ? (
                          <Button disabled className="quantitybtn">
                            +
                          </Button>
                        ) : (
                          <Button
                            onClick={this.increment}
                            className="quantitybtn"
                          >
                            +
                          </Button>
                        )}
                      </Col>
                      <Col lg={4} md={4} sm={24} xs={24}>
                        <span className="perton">
                          {this.state.count + " Pallet(s)"}
                        </span>
                      </Col>
                      <Col lg={6} md={6} sm={24} xs={24}>
                        <Select
                          className="deliveryTruckSelect"
                          notFoundContent={"Not found?!"}
                          placeholder="Delivery Vehicle"
                          onChange={(value) =>
                            this.setState({
                              deliveryTruck: value,
                            })
                          }
                          style={{ width: "100%" }}
                          value="Customer Pickup"
                        >
                          {/* <Option value="Flatbed">Flatbed</Option>

                          <Option value="Flatbed with forklift">
                            Flatbed with forklift
                          </Option> */}

                          <Option value="CustomerPickup">
                            Customer Pickup
                          </Option>
                        </Select>
                      </Col>
                      <Col lg={6} md={6} sm={24} xs={24}>
                        <Button
                          className="orderbtn"
                          style={{ marginLeft: "50px", marginTop: "-10px" }}
                          onClick={() =>
                            this.addToCart(
                              this.state.stoneData.length > 0 &&
                                this.state.stoneData[0]["location"]
                            )
                          }
                          loading={this.state.addToCartLoading}
                        >
                          Add to Cart
                        </Button>
                      </Col>
                    </Row>
                  )}
                </Row>

                <span className="abouttext">
                  Sales Representative for your area
                </span>
                <Row style={{ marginTop: "2%" }}>
                  <Col lg={12} md={12} smn={24} xs={24}>
                    <div style={{ marginTop: "2%" }}>
                      <p
                        style={{
                          fontWeight: "bold",
                          color: "black",
                          fontSize: "16px",
                          marginBottom: "0px",
                        }}
                      >
                        {southernStates?.southernName}
                      </p>
                      <p style={{ fontSize: "16px", marginBottom: "0px" }}>
                        {southernStates?.southernEmail}
                      </p>
                      <p style={{ fontSize: "16px" }}>
                        {southernStates?.southernPhone}
                      </p>
                    </div>
                  </Col>
                  {/* <Col lg={12} md={12} smn={24} xs={24}>
                    <h3 style={{ fontWeight: "bold", fontSize: "17px" }}>
                      Northern states:
                    </h3>
                    <div style={{ marginTop: "4%" }}>
                      <p
                        style={{
                          fontWeight: "bold",
                          color: "black",
                          fontSize: "16px",
                          marginBottom: "0px",
                        }}
                      >
                        {northernStates?.northernName}
                      </p>
                      <p style={{ fontSize: "16px", marginBottom: "0px" }}>
                        {northernStates?.northernEmail}
                      </p>
                      <p style={{ fontSize: "16px" }}>
                        {northernStates?.northernPhone + " ext. 2"}
                      </p>
                    </div>
                  </Col> */}
                </Row>
              </div>
            </Col>
          </Spin>
        </Row>
      </div>
    );
  }
}

export default withAppContext(withRouter(Stonedetails));
// export default Stonedetails;
